<!--  -->
<template>
  <div class="total">
    <img style="width: 100%" src="/static/img/title4.png" alt="" />
    <div style="margin: 0.7rem 0">
      <h3 class="content-title">关于我们</h3>
      <div>ABOUT US</div>
    </div>
    <div class="introduce"></div>
    <div class="introduceImg-box">
      <!-- <img
        class="introduce-img"
        style=""
        src="/static/img/aboutTitle.png"
        alt=""
      /> -->
      <vue-flux
        class="introduce-img"
        :options="vfOptions"
        :images="vfImages"
        :transitions="vfTransitions"
        ref="slider"
      >
        <template v-slot:caption>
          <flux-caption />
        </template>
      </vue-flux>
    </div>
    <div class="introduce-text">
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;我们是一家致力于“互联网+医疗健康”的科技型企业，广州呼吸健康研究院的何建行院长是我们的医疗技术总顾问，我们依托广医、浙大、中南大学等院校的人才和技术，以一批国际、国内知名的医学、图像识别和计算机科学家，领衔建设疾病联防联控平台，自主研发数据无损压缩、GPU图像渲染、云平台大数据归档管理与快速检索、区块链加密等技术，实现区域内影像数据的互联互通互认。公司成立以来，为服务我国的疾病预防和控制工作尽一份绵薄之力，得到上级领导的充分肯定和社会各界的高度评价。
    </div>
    <div style="margin: 0.7rem 0">
      <h3 class="content-title">专利资质</h3>
      <div>PATENT QUALIFICATION</div>
    </div>
    <div class="title">
      <swiper
        :options="swiperOption"
        ref="mySwiper"
        style="
          transform: translate3d(0, 0, 0);
          overflow: hidden;
          width: 7.5rem;
          height: 5.9rem;
        "
      >
        <swiper-slide
          v-for="(item, index) in title"
          :key="index"
          style="transform: translate3d(0, 0, 0); width: 7.5rem"
        >
          <div class="qualifications">
            <img
              :class="'qualifications-img'"
              v-for="item2 in item"
              :key="item2.url"
              :src="item2.url"
              alt=""
            />
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
      </swiper>
    </div>
  </div>
</template>

<script>
import {
  VueFlux,
  FluxCaption,
  FluxControls,
  FluxIndex,
  FluxPagination,
  FluxPreloader,
} from "vue-flux";
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    swiper,
    swiperSlide,
    VueFlux,
    FluxCaption,
    FluxControls,
    FluxIndex,
    FluxPagination,
    FluxPreloader,
  },
  data() {
    return {
      vfOptions: {
        autoplay: true,
      },
      vfImages: [
        "/static/img/aboutTitle.png",
        "/static/img/aboutTitle1.png",
      ],
      vfTransitions: ["zip"],
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 5000,
          // stopOnLastSlide: false,
          // disableOnInteraction: false,
        },
        // autoplay: true,
        // speed: 5000,
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      title: [],
    };
  },

  mounted() {
    this.produceTitle();
  },

  methods: {
    produceTitle() {
      for (let index = 0; index < 9; index++) {
        this.title.push([
          {
            url: "/static/img/资质/" + (index * 6 + 1) + ".jpg",
          },
          {
            url: "/static/img/资质/" + (index * 6 + 2) + ".jpg",
          },
          {
            url: "/static/img/资质/" + (index * 6 + 3) + ".jpg",
          },
          {
            url: "/static/img/资质/" + (index * 6 + 4) + ".jpg",
          },
          {
            url: "/static/img/资质/" + (index * 6 + 5) + ".jpg",
          },
          {
            url: "/static/img/资质/" + (index * 6 + 6) + ".jpg",
          },
        ]);
      }
      // this.title.push([
      //   {
      //     url: "/static/img/资质/8 (1)" + ".jpg",
      //   },
      //   {
      //     url: "/static/img/资质/8 (2)" + ".jpg",
      //   },
      //   {
      //     url: "/static/img/资质/8 (3)" + ".jpg",
      //   },
      //   {
      //     url: "/static/img/资质/8 (4)" + ".jpg",
      //   },
      // ]);
      // console.log(this.title);
    },
  },
};
</script>
<style lang='less' scoped>
.swiper-button-prev {
  outline: none;
  background-image: url(../../static/img/home/left.png);
}
.swiper-button-next {
  outline: none;
  background-image: url(../../static/img/home/right.png);
}

.swiper-pagination /deep/ .swiper-pagination-bullet {
  width: 16px;
  height: 2px;
  border-radius: 2px;
}

.total {
  width: 100%;
  height: 100%;
  margin-bottom: 80px;
}
.qualifications {
  display: flex;
  flex-wrap: wrap;
  width: 6rem;
  margin: 0 auto;
  .qualifications-img {
    width: 1.8rem;
    height: 2.5rem;
    // margin: 5px 0.15rem;
    margin: 5px auto;
  }
  .qualifications-img2 {
    width: 4.5rem;
    margin: 10px auto;
  }
}
.content-title {
  color: #464c4f;
  font-size: 0.4rem;
}

.introduceImg-box {
  width: 7rem;
  // height: 3.6rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.introduce-img {
  width: 100%;
  height: 100%;
  transition: all 0.3s;
}
// .introduce-img:hover {
//   width: 110%;
//   height: 110%;
// }
.introduce-text {
  width: 7rem;
  margin: 0.7rem auto;
  font-size: 0.32rem;
  line-height: 0.54rem;
  text-align: left;
}

.title {
  margin: 0 auto;
  width: 7.5rem;
  height: 100%;
  // height: 1000px;
  .title-logo {
    width: 2rem;
    margin: 14px 1.5rem 14px 4.7rem;
  }
}

.title /deep/.el-carousel__button {
  background-color: #03265c;
  width: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs.vue